import React, { useEffect, useState, useContext, Fragment  } from "react";
import { useNavigate, useLocation } from "react-router-dom"
import { AdTable } from "../components/adTable";
import { AdTile } from "../components/adTile";
import { api_domain } from "../config"
import Menu from "../components/navbar.js";
import { AuthContext } from "../components/AuthContext";

// TODO: advanced search - dropdowns for each field - parent_url, landing_url, batch.human_name
// TODO: filters - batch.batch_type
// TODO: loading animation or some indication that ads are loading


function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

export function Search() {
  const [results, setResults] = useState(null);
  const { basicHttpAuthString } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  let params = useQuery();

  let cur_page = parseInt(params.get("page")) ? parseInt(params.get("page")) : 1
  let view = params.get("view")
  let blur = params.get("blur")
  if (!view ) {
    if (!blur) {
      navigate(location.pathname + location.search + "&view=table&blur=true")
    } else {
      navigate(location.pathname + location.search.substring(0, location.search.indexOf("blur")) + "view=table&blur=" + blur)
    }
  } else {
    if (!blur) { 
      navigate(location.pathname + location.search + "&blur=true")
    }
  }
  
  useEffect(() => {
    if (location.search !== "" && !parseInt(params.get("page"))) {
        navigate(location.pathname + location.search + "&page=1")
    }    
}, [location, navigate, params])

  const prev_page = () => {
    navigate(location.pathname + location.search.substring(0, location.search.indexOf("page")) + `page=${cur_page-1}&view=${view}&blur=${blur}`)
  }

  const next_page = () => {
    navigate(location.pathname + location.search.substring(0, location.search.indexOf("page")) + `page=${cur_page+1}&view=${view}&blur=${blur}`)
  }

  useEffect(() => {
    let query = `${api_domain}/search/ad?`
    if (params.get("query")) {
      query += "&text_description_query=" + params.get("query")
    }
    if (params.get("start_date")) {
      query += "&batch_datetime_start=" + params.get("start_date") + "T00:00:00"
    }
    if (params.get("end_date")) {
      query += "&batch_datetime_end=" + params.get("end_date") + "T00:00:00"
    }
    if (params.get("batch_id")) {
      query += "&batch_id=" + params.get("batch_id")
    }
    if (params.get("parent_domain")) {
      query += "&parent_url_query=" + params.get("parent_domain")
    }
    if (params.get("landing_domain")) {
      query += "&landing_url_query=" + params.get("landing_domain")
    }

    if (query !== `${api_domain}/search/ad?`) {
      // fields that can be made available to the client
      query += "&order_by=id_asc"
      query += "&page=" + cur_page
      query += "&size=25"

      fetch(query, {
        headers: {
          Authorization: `${basicHttpAuthString}`
        }
      })
        .then((response) => response.json())
        .then((data) => setResults(data));
    }
  }, [params, cur_page])


  let searchHandler = (event) => {
    event.preventDefault();
    const formData = new FormData(event.target),
      formDataObj = Object.fromEntries(formData.entries());

    let navigate_url = `/search?`
    if(formDataObj.query !== "") {
      navigate_url += `query=${formDataObj.query}`
    }
    if (formDataObj.start_date !== "") {
      navigate_url += `&start_date=${formDataObj.start_date}`
    }
    if (formDataObj.end_date !== "") {
      navigate_url += `&end_date=${formDataObj.end_date}`
    }
    if (formDataObj.parent_domain !== "") {
      navigate_url += `&parent_domain=${formDataObj.parent_domain}`
    }
    if (formDataObj.landing_domain !== "") {
      navigate_url += `&landing_domain=${formDataObj.landing_domain}`
    }
    if (formDataObj.batch_id !== "") {
      navigate_url += `&batch_id=${formDataObj.batch_id}`
    }
    navigate_url += '&page=1'
    navigate_url += `&view=${view}`
    navigate_url += `&blur=${blur}`
    navigate(navigate_url);
  };

  return (
    <Fragment>
     <div className="container">
    <Menu/> 
    <div className="tools">
    <div className="titleMain">Search</div>
      <form className="searchForm" onSubmit={searchHandler}>
     
      {/*-------------------------------------------------------------*/}
        <div className="searchRow">
          <input
            name="query"
            type="text"
            className="searchFieldOne"
            placeholder="Enter your query"
            defaultValue={params.get("query") ? params.get("query") : ""}
          />
          <button className="buttonSearch" variant="primary" type="submit">Search</button>
        </div>
       {/*-------------------------------------------------------------*/}
        <div className="searchRow">

          <div className="searchCol">
            <label htmlFor="parent_domain" className="searchFormLabel">Parent URL</label>
            <input
              name="parent_domain"
              type="text"
              className="searchFieldTwo"
              placeholder="e.g. cs.washington.edu"
              defaultValue={params.get("parent_domain") ? params.get("parent_domain") : ""}
            />
          </div>

          {/*/////////////////////////////////*/}

          <div className="searchCol">
            <label htmlFor="landing_domain" className="searchFormLabel">Landing URL</label>
            <input
              name="landing_domain"
              type="text"
              className="searchFieldTwo"
              placeholder="e.g. cs.washington.edu"
              defaultValue={params.get("landing_domain") ? params.get("landing_domain") : ""}
            />
          </div>
        </div>

      {/*-------------------------------------------------------------*/}

        <div className="searchRow" style={{ "marginTop": "6px" }}>
          <div className="searchCol">
            <label htmlFor="batch_id" className="searchFormLabel">Batch Id</label>
            <input
              name="batch_id"
              type="number"
              className="searchFieldTwo"
              placeholder="e.g. 1"
              defaultValue={params.get("batch_id") ? params.get("batch_id") : ""}
            />
          </div>

          <div className="searchCol">
            <label htmlFor="start_date" className="searchFormLabel">
              Start Date
            </label>
            <input
              type="date"
              className="searchFieldTwo"
              name="start_date"
              id="start_date"
              defaultValue={params.get("start_date") ? params.get("start_date") : ""} //"2019-06-13"
            />
          </div>
          <div className="searchCol">
            <label htmlFor="end_date" className="searchFormLabel">
              End Date
            </label>
            <input
              type="date"
              className="searchFieldTwo"
              name="end_date"
              id="end_date"
              defaultValue={params.get("end_date") ? params.get("end_date") : ""}
            />
          </div>
        </div>
      </form>
      <br/>
      {results !== null && (results.items.length === 0 ? <div className="noResult">No results found!</div> :
        <div>
          <div className="btn-group" data-toggle="buttons">
            <input type="radio" className="btn-check" name="options" id="table" checked={view === "table"} onChange={() => navigate(location.pathname + location.search.substring(0, location.search.indexOf("view")) + `view=table` + `&blur=` + params.get("blur"))}/>
            <label className="btn btn-secondary" htmlFor="table">Table View</label>
            <input type="radio" className="btn-check" name="options" id="tile" checked={view !== "table"} onChange={() => navigate(location.pathname + location.search.substring(0, location.search.indexOf("view")) + `view=tile` + `&blur=` + params.get("blur"))}/>
            <label className="btn btn-secondary" htmlFor="tile">Tile View</label>

	    {params.get("blur") === "true" ? <input type="radio" className="btn-check" name="options" id="blur" onClick={() => navigate(location.pathname + location.search.substring(0, location.search.indexOf("blur")) + `blur=false`)}/> : <input type="radio" className="btn-check" name="options" id="blur" onClick={() => navigate(location.pathname + location.search.substring(0, location.search.indexOf("blur")) + `blur=true`)}/> }
	    {params.get("blur") === "true" ? <label className="btn btn-secondary" htmlFor="blur">Unblur Screenshots</label> : <label className="btn btn-secondary" htmlFor="blur">Blur Screenshots</label>}
          </div>
          {view === "table" ? <AdTable results={results} prev_page={prev_page} next_page={next_page} blur={params.get("blur")}/> : <AdTile results={results} prev_page={prev_page} next_page={next_page} blur={params.get("blur")}/>}
        </div>)}
    </div>
    </div>
    </Fragment>
  );
}
